import React from "react";
import { inlineLoadingStyles } from "./styles";
import AnimatedDots from "../input-area/AnimatedDots";

const KolegaInlineLoading = ({ isVisible = false }) => {


  if (!isVisible) return null;

  return (
    <>
      <style>{inlineLoadingStyles}</style>

      <div className="inline-flex items-center justify-center gap-3 relative w-full">
        <div className="flex items-center gap-3">
          {/* Animated Kolega Icon */}
          <div className="kolega-icon-container">
            <svg
              className="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="kolega-icon-bracket-left"
                d="M7 8L3 12L7 16"
                stroke="#ADDD30"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                className="kolega-icon-bracket-right"
                d="M17 8L21 12L17 16"
                stroke="#ADDD30"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                className="kolega-icon-slash"
                d="M10 20L14 4"
                stroke="#ADDD30"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          
          {/* Thinking text with dots */}
          <div className="flex items-center gap-1">
            <span className="text-sm text-neutral-500 dark:text-neutral-400">Thinking</span>
            <AnimatedDots />
          </div>
        </div>
      </div>
    </>
  );
};

export default KolegaInlineLoading;
